import React from 'react';
import { AutoComplete, Card, Col, Form, Row, Select } from 'antd';
import { GeographicScope } from '../../types/survey.types';

type GeoOption = {
  value: string;
  label: string;
};

interface SurveyLocationCardProps {
  geographicScope: GeographicScope;
  showScopeSelector?: boolean;
  scopeDisabled?: boolean;
  onScopeChange?: (value: GeographicScope) => void;

  countryInputValue: string;
  stateInputValue: string;
  cityInputValue: string;
  countryOptions: GeoOption[];
  stateOptions: GeoOption[];
  cityOptions: GeoOption[];

  countryDisabled: boolean;
  stateDisabled: boolean;
  cityDisabled: boolean;

  searchingCountries: boolean;
  searchingStates: boolean;
  searchingCities: boolean;

  onCountrySearch: (value: string) => void;
  onCountrySelect: (value: string) => void;
  onStateSearch: (value: string) => void;
  onStateSelect: (value: string) => void;
  onCitySearch: (value: string) => void;
  onCitySelect: (value: string) => void;

  countryHelperText?: string;
  stateHelperText?: string;
  cityHelperText?: string;
}

export const SurveyLocationCard: React.FC<SurveyLocationCardProps> = ({
  geographicScope,
  showScopeSelector = false,
  scopeDisabled = false,
  onScopeChange,
  countryInputValue,
  stateInputValue,
  cityInputValue,
  countryOptions,
  stateOptions,
  cityOptions,
  countryDisabled,
  stateDisabled,
  cityDisabled,
  searchingCountries,
  searchingStates,
  searchingCities,
  onCountrySearch,
  onCountrySelect,
  onStateSearch,
  onStateSelect,
  onCitySearch,
  onCitySelect,
  countryHelperText,
  stateHelperText,
  cityHelperText,
}) => {
  return (
    <Card title="Localização Geográfica" style={{ marginTop: 16 }}>
      <Row gutter={16}>
        {showScopeSelector && (
          <Col span={24}>
            <Form.Item label="Abrangência Geográfica" required>
              <Select
                value={geographicScope}
                onChange={(value) => onScopeChange?.(value as GeographicScope)}
                disabled={scopeDisabled}
                placeholder="Selecione a abrangência"
              >
                <Select.Option value={GeographicScope.NATIONAL}>Nacional</Select.Option>
                <Select.Option value={GeographicScope.STATE}>Estadual</Select.Option>
                <Select.Option value={GeographicScope.CITY}>Municipal</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        )}

        <Col span={8}>
          <Form.Item label="País" required={geographicScope === GeographicScope.NATIONAL}>
            <AutoComplete
              value={countryInputValue}
              placeholder="Digite para buscar país"
              disabled={countryDisabled}
              onSearch={onCountrySearch}
              onSelect={onCountrySelect}
              notFoundContent={searchingCountries ? 'Buscando...' : 'Nenhum país encontrado'}
              options={countryOptions}
            />
            {countryHelperText && (
              <div style={{ color: '#999', fontSize: 12, marginTop: 4 }}>
                {countryHelperText}
              </div>
            )}
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="Estado" required={geographicScope === GeographicScope.STATE}>
            <AutoComplete
              value={stateInputValue}
              placeholder="Digite para buscar estado"
              disabled={stateDisabled}
              onSearch={onStateSearch}
              onSelect={onStateSelect}
              notFoundContent={searchingStates ? 'Buscando...' : 'Nenhum estado encontrado'}
              options={stateOptions}
            />
            {stateHelperText && (
              <div style={{ color: '#999', fontSize: 12, marginTop: 4 }}>
                {stateHelperText}
              </div>
            )}
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item label="Cidade" required={geographicScope === GeographicScope.CITY}>
            <AutoComplete
              value={cityInputValue}
              placeholder="Digite para buscar cidade"
              disabled={cityDisabled}
              onSearch={onCitySearch}
              onSelect={onCitySelect}
              notFoundContent={searchingCities ? 'Buscando...' : 'Nenhuma cidade encontrada'}
              options={cityOptions}
            />
            {cityHelperText && (
              <div style={{ color: '#999', fontSize: 12, marginTop: 4 }}>
                {cityHelperText}
              </div>
            )}
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default SurveyLocationCard;